var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE1ReceivePo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-E1_Receive_PO"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E1_Receive_PO",
    "data-name": "E1 Receive PO",
    clipPath: "url(#clip-E1_Receive_PO)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11806",
    "data-name": "Group 11806",
    transform: "translate(0.888 2.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11807",
    "data-name": "Group 11807",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22282",
    "data-name": "Path 22282",
    d: "M16.224,8.2V8.7c-.008.006-.021.011-.023.018a1.425,1.425,0,0,1-.811.987c-1.094.555-2.181,1.124-3.272,1.683-.749.384-1.493.779-2.262,1.124a4.518,4.518,0,0,1-1.141.337H7.891a.1.1,0,0,0-.086-.031,3.249,3.249,0,0,1-1.063-.273c-.817-.366-1.633-.732-2.445-1.108a2.849,2.849,0,0,0-1.437-.291c-.123.009-.174.041-.154.165a.537.537,0,0,1,0,.095c0,.3-.13.427-.439.427H.417A.364.364,0,0,1,0,11.419Q0,8.608,0,5.8a.342.342,0,0,1,.388-.387H2.3a.35.35,0,0,1,.406.39c.008.24.008.24.249.211C2.981,6.009,3,6,3.022,6A9.257,9.257,0,0,1,4.56,5.856c.13.006.169-.025.168-.161q-.007-2.636,0-5.273c0-.286.134-.422.41-.422h9.251c.384,0,.487.1.487.487q0,2.2,0,4.4c0,.686,0,1.372,0,2.058,0,.094.015.145.131.157a1.36,1.36,0,0,1,.815.377,1.754,1.754,0,0,1,.4.715M14.2,4c0-1.055,0-2.111,0-3.166,0-.113-.021-.154-.146-.154q-1.2.009-2.407,0c-.12,0-.149.035-.148.152.007.485,0,.971,0,1.456a.379.379,0,0,1-.226.4.385.385,0,0,1-.345-.053c-.347-.166-.69-.339-1.032-.515a.183.183,0,0,0-.189,0c-.347.177-.7.35-1.046.522-.311.153-.55.005-.551-.338,0-.491,0-.981,0-1.472,0-.123-.038-.148-.153-.148q-1.2.007-2.391,0c-.125,0-.158.032-.158.158.005,1.06,0,2.121,0,3.182,0,.607,0,1.214,0,1.82,0,.049-.032.115.058.139a9.885,9.885,0,0,1,1.637.695c.878.408,1.766.795,2.623,1.248a1.3,1.3,0,0,1,.741,1.081c.017.179.074.131.174.079q1.71-.875,3.422-1.745a.194.194,0,0,0,.125-.2c0-1.045,0-2.089,0-3.134M2.706,8.6h0c0,.565.006,1.129,0,1.694,0,.155.043.2.195.186a3,3,0,0,1,1.562.291c.776.365,1.558.717,2.34,1.07a3.285,3.285,0,0,0,2.91-.01c1.841-.89,3.642-1.859,5.467-2.781a.644.644,0,0,0,.308-.328.694.694,0,0,0-.147-.76.682.682,0,0,0-.82-.09Q12.137,9.094,9.754,10.32a1.267,1.267,0,0,1-1.023.094A10.769,10.769,0,0,1,7.7,9.945c-.592-.274-1.182-.554-1.772-.833a.348.348,0,0,1-.217-.352.358.358,0,0,1,.273-.3.38.38,0,0,1,.285.063c.842.4,1.682.8,2.524,1.2a.683.683,0,1,0,.577-1.237q-.713-.339-1.427-.677C7.2,7.466,6.469,7.087,5.706,6.783A3.1,3.1,0,0,0,4.258,6.54c-.467.042-.93.116-1.4.161-.127.012-.159.055-.158.173,0,.575,0,1.15,0,1.725m-.677.02c0-.8,0-1.593,0-2.389,0-.1-.018-.147-.138-.144-.337.01-.676.013-1.013,0-.156-.005-.2.035-.2.2.007,1.145,0,2.289,0,3.434,0,.417.007.833,0,1.25,0,.146.044.183.186.179.337-.01.676-.009,1.013,0,.125,0,.158-.031.157-.157-.006-.791,0-1.582,0-2.374M9.808.687c-.29,0-.581.007-.871,0-.126,0-.15.043-.148.153.006.279.007.559,0,.838,0,.112.03.13.124.081.205-.108.412-.212.617-.32a.535.535,0,0,1,.527,0c.206.107.416.2.618.319.122.069.135.028.133-.087-.005-.274-.007-.549,0-.823,0-.116-.028-.159-.149-.156-.285.007-.57,0-.855,0",
    transform: "translate(0 0)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22283",
    "data-name": "Path 22283",
    d: "M363.064,192.13c-.206,0-.411,0-.617,0a.346.346,0,1,1,0-.688q.632,0,1.265,0a.346.346,0,1,1,0,.687c-.216,0-.432,0-.648,0",
    transform: "translate(-350.571 -185.362)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE1ReceivePo);
export default __webpack_public_path__ + "static/media/E1 Receive PO.6702bb6f751c441a977f45251b8a862e.svg";
export { ForwardRef as ReactComponent };